var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"create-account"},[_c('b-container',[_c('CreateSteps',{attrs:{"activeStep":_vm.activeStep}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }